"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _ramda = require("ramda");

var _useConvertCurrency2 = _interopRequireDefault(require("../hooks/useConvertCurrency"));

var _ConversionResult = _interopRequireDefault(require("./ConversionResult"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    root: {
      padding: spacing(1.5, 2, 1, 1.5),
      border: "1px solid ".concat(palette.dividerLight),
      borderRadius: 3
    }
  };
});

var CurrencyConverter = function CurrencyConverter(_ref2) {
  var price = _ref2.price,
      fromCurrencyId = _ref2.fromCurrencyId,
      toCurrencyIds = _ref2.toCurrencyIds;
  var classes = useStyles();
  var shouldConvert = Boolean(price > 0 && price <= 5000 && fromCurrencyId && toCurrencyIds.length > 0);
  var uniqCurrencyIds = (0, _react.useMemo)(function () {
    return (0, _ramda.uniq)(toCurrencyIds);
  }, [toCurrencyIds]);

  var _useConvertCurrency = (0, _useConvertCurrency2.default)({
    fromCurrencyId,
    toCurrencyIds: uniqCurrencyIds,
    price,
    shouldConvert
  }),
      conversions = _useConvertCurrency.conversions,
      isLoading = _useConvertCurrency.isLoading;

  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, "Currency converter"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    my: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, "Gift card amount will be rounded"), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    title: "The exact converted cost will be calculated once your recipient has accepted the gift.",
    placement: "top-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    "data-testid": "CurrencyConverter.ApproximateCharge.Hint",
    color: "grey.main",
    icon: "info-circle",
    fontSize: 1
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    whiteSpace: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 65%"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Recipient receives"))), !isLoading && shouldConvert && conversions.map(function (conversion) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      pt: 1,
      pb: 1,
      whiteSpace: "nowrap",
      key: conversion.toCurrencyId
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      flex: "1 1 65%",
      "data-testid": "CurrencyConverter.ConversionResult"
    }, /*#__PURE__*/_react.default.createElement(_ConversionResult.default, {
      fromCurrencyId: conversion.fromCurrencyId,
      toCurrencyId: conversion.toCurrencyId,
      resultPrice: conversion.convertedPrice,
      exchangeRate: conversion.exchangeRate
    })));
  }), isLoading && uniqCurrencyIds.map(function (id) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      pt: 1.5,
      pb: 1.5,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
      width: "65%",
      height: 40
    }), /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
      width: "35%",
      height: 40,
      ml: 2
    }));
  }), !isLoading && !shouldConvert && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2.5,
    mb: 2.5,
    "data-testid": "CurrencyConverter.NoData"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Not calculated")));
};

var _default = /*#__PURE__*/(0, _react.memo)(CurrencyConverter);

exports.default = _default;